import React from "react";
import {Skeleton} from "@material-ui/lab";
import {Typography} from "@material-ui/core";

export const TypographyPreviewfy = ({preview = false, width = 120, height = 30, text, style, ...props}) =>
  preview
    ?
    <Skeleton width={width} height={height} style={{borderRadius: 10, ...style}}/>
    :
    <Typography style={style} {...props}>{text}</Typography>